import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpService, LocalStorageService } from 'brainloper-ui';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { MenuBreadCrumb } from 'brainloper-ui';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-indicators-maintenance',
  templateUrl: './indicators-maintenance.component.html',
  styleUrls: ['./indicators-maintenance.component.scss']
})
export class IndicatorsMaintenanceComponent implements OnInit {

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: "Indicadores Mantenimiento",
      current: true
    }
  ]

  constructor(

  ) { }


  async ngOnInit() {
  }
}
